import {
  create,
  show,
  getList,
  update,
  remove,
  nextPage,
  changePage,
  checkmail,
  countSubAccount,
} from '@/apis/sub-account';
import { SUB_ACCOUNT } from '../mutation-types';

export const state = {
  disable: false,
  account: {
    category: [],
    list: [],
  },
  subAccount: {},
  countSubAccount: {},
  updateRes: '',
  createRes: '',
  deleteRes: '',
  alert: {
    content: '',
    toggle: false
  },
  fromWhere: ''
};

export const getters = {
  disable: (state) => state.disable,
  subAccountList: (state) => state.account,
  subAccount: (state) => state.subAccount,
  countSubAccount: (state) => state.countSubAccount,
  deleteRes: (state) => state.deleteRes,
  alert: (state) => state.alert,
  fromWhere: (state) => state.fromWhere
};

export const mutations = {
  [SUB_ACCOUNT.GET_LIST](state, data) {
    if (!data.error) {
      state.account = data;
    }
  },
  [SUB_ACCOUNT.GET_LIST](state, data) {
    if (!data.error) {
      state.account = data;
    }
  },
  [SUB_ACCOUNT.GET_DETAIL](state, data) {
    if (!data.error) {
      state.subAccount = data;
    }
  },
  [SUB_ACCOUNT.UPDATE_RES](state, data) {
    state.updateRes = data;
  },
  [SUB_ACCOUNT.CREATE_RES](state, data) {
    state.createRes = data;
  },
  [SUB_ACCOUNT.DELETE_RES](state, data) {
    state.deleteRes = data;
  },
  [SUB_ACCOUNT.ALERT](state, data) {
    state.alert = data;
  },
  [SUB_ACCOUNT.COUNT_SUB_ACCOUNT](state, data) {
    state.countSubAccount = data;
  },
  [SUB_ACCOUNT.SET_DISABLE](state, data) {
    state.disable = data;
  },
  [SUB_ACCOUNT.FORM_WHERE](state, data) {
    state.fromWhere = data;
  },
};

export const actions = {
  setFromWhere({ commit }, param) {
    commit(SUB_ACCOUNT.FORM_WHERE, param);
  },
  setDisable({ commit }, param) {
    commit(SUB_ACCOUNT.SET_DISABLE, param);
  },
  setAlert({ commit }, param) {
    commit(SUB_ACCOUNT.ALERT, param);
  },
  async getList({ commit }, param) {
    const res = await getList(param);
    commit(SUB_ACCOUNT.GET_LIST, res);
  },
  async create({ commit }, data) {
    const res = await create(data);
    commit(SUB_ACCOUNT.CREATE_RES, res);
    return res;
  },
  async show({ commit }, id) {
    const res = await show(id);
    commit(SUB_ACCOUNT.GET_DETAIL, res);
  },
  async update({ commit }, data) {
    const res = await update(data.id, data);
    commit(SUB_ACCOUNT.UPDATE_RES, res);
    return res;
  },
  async delete({ commit }, data) {
    const res = await remove(data);
    commit(SUB_ACCOUNT.DELETE_RES, res);
    return res;
  },
  async check({ commit }, data) {
    const res = await checkmail(data);
    if (res) {
      return res;
    }
    return false;
  },
  async nextPage({ commit }, param) {
    const res = await nextPage(param);
    commit(SUB_ACCOUNT.GET_LIST, res);
  },
  async changePage({ commit }, param) {
    const res = await changePage(param);
    commit(SUB_ACCOUNT.GET_LIST, res);
  },
  async countSubAccount({ commit }, param) {
    const res = await countSubAccount(param);
    commit(SUB_ACCOUNT.COUNT_SUB_ACCOUNT, res);
  },
};
